import MonitorIndex from "./home.vue"
import MonitorIndexView from "./dataV.vue"
let a = Object.assign({ MonitorIndex, MonitorIndexView })
export default a;
